import TemplateNames from '../email-messages/TemplateNames';
import MarketingSubscriptionSources from '../followers/MarketingSubscriptionSources';

export default {
  title: 'Marketingoverzicht',
  tiles: {
    followers: 'Volgers',
    delivered_messages: 'Afgeleverde berichten',
    open_rate: 'Openratio',
    click_rate: 'Klikratio',
    spam_report_rate: 'Spamklachten',
    unsubscribe_rate: 'Uitschrijfpercentage',
  },
  subscriprion_sources_table: {
    source_names: MarketingSubscriptionSources,
    columns: {
      subscription_source: 'Abonnementsbron',
      count: 'Aantal',
      percentage: 'Percentage',
    },
  },
  templates_table: {
    template_names: TemplateNames,
    columns: {
      template: 'Sjabloon',
      delivered: 'Afgeleverd',
      open_rate: 'Openratio',
      click_rate: 'Klikratio',
      spam_report_rate: 'Spamklachten',
      unsubscribe_rate: 'Uitschrijfpercentage',
    },
  },
  labels: {
    no_data: 'Geen gegevens',
  },
  toasts: {
    failed_to_load_data: 'Gegevens laden mislukt',
  },
};
